/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2021-12-28 11:30:34
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-05 11:51:48
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/api/router.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/iam/router/getList?sysCode=mehz',
    method: 'get',
    params,
  })
}
